import Head from 'next/head';
import React from 'react';
import generateMetaTags from '../components/layout/MetaTags';
import ValuationsSalesPage from '../components/valuation/ValuationsSalesPage';

const metaData = {
  title: 'Empowering agents, accelerating success',
  url: `/agent-advantage`,
};

const AgentAdvantage = () => {
  return (
    <>
      <Head>{generateMetaTags(metaData)}</Head>

      <ValuationsSalesPage />
    </>
  );
};

export default AgentAdvantage;
